import { BlockBlobClient } from "@azure/storage-blob";

export const uploadChunkToAzure = async (
  containerUrl: string,
  sasToken: string,
  blobPathPrefix: string,
  chunkIndex: number,
  chunkBlob: Blob,
  extension: string,
): Promise<void> => {
  const normalizedToken = sasToken.startsWith('?') ? sasToken.slice(1) : sasToken;
  const blobUrl = `${containerUrl}/${blobPathPrefix}chunk_${chunkIndex}${extension}?${normalizedToken}`;
  const blockBlobClient = new BlockBlobClient(blobUrl);

  await blockBlobClient.uploadData(chunkBlob, {
    blobHTTPHeaders: {
      blobContentType: chunkBlob.type,
    },
  });
};

export const uploadFileToAzure = async (
  containerUrl: string,
  sasToken: string,
  blobPathPrefix: string,
  file: File,
  extension: string,
  onProgress?: (percentage: number) => void,
): Promise<void> => {
  const normalizedToken = sasToken.startsWith("?")
    ? sasToken.slice(1)
    : sasToken;
  const blobUrl = `${containerUrl}/${blobPathPrefix}chunk_0${extension}?${normalizedToken}`;
  const blockBlobClient = new BlockBlobClient(blobUrl);

  await blockBlobClient.uploadData(file, {
    blobHTTPHeaders: {
      blobContentType: file.type,
    },
    maxSingleShotSize: 4 * 1024 * 1024,
    blockSize: 4 * 1024 * 1024,
    concurrency: 4,
    onProgress: (ev) => {
      if (onProgress && file.size > 0) {
        onProgress(Math.round((ev.loadedBytes * 100) / file.size));
      }
    },
  });
};
